import * as actionTypes from "./types";

export const actionError = (payload) => {
  return {
    type: actionTypes.ACTION_ERROR,
    payload,
  };
};
